module.exports = __webpack_public_path__ + "img/scroll-up-button.d7554976.svg";